/**
* @author XuZiYu
* @date 2019/7/4
* @time 09:43
*/
<template>
    <div class="wrapper-detail">
        <!--页面-内容-->
        <share-ad :detail="shareData">
            <div class="wrapper-detail-content">
                <van-skeleton
                        title
                        :row="5"
                        animate
                        avatar
                        avatar-size="90vw"
                        avatar-shape="square"
                        :loading="warpLoading"
                >
                    <van-swipe ref="swipe" :autoplay="3000" @change="onSwipeChange">
                        <van-swipe-item v-for="(v,i) in info.imgUrls" :key="i" @click="onPPreview(i)">
                            <img :src="v" alt=""/>
                        </van-swipe-item>
                        <div class="custom-indicator" slot="indicator">
                            {{ current + 1 }}/{{info.imgUrls.length}}
                        </div>
                    </van-swipe>
                    <div class="title">
                        <h2>{{info.name}}</h2>
                        <p>
                            <b>{{info.rmbPrice ? info.beanPrice ? `¥${info.rmbPrice}+` : `¥${info.rmbPrice}` :''}}{{info.beanPrice ? info.beanPrice: ''}}</b>{{info.beanPrice ? '斑豆' : '' }}
                        </p>
                    </div>
                    <div class="item">
                        <span>退款信息</span>
                        <span>{{info.refundFlag ? '支持退款' : '不支持退款'}}</span>
                    </div>
                    <div class="info" v-html="info.detail">
                    </div>
                </van-skeleton>
                <ctl-dialog v-model="dialogData"/>
            </div>
            <van-button v-if="$route.query.shareType === 'h5'" class="btn-submit" @click="submit">App购买</van-button>
            <van-button v-else :class="['btn-submit',disabled && 'disabled']" @click="submit" :loading="loading">{{disabled ? '已售罄' :  Number(appType) === 100? '立即购买' : '立即兑换'}}</van-button>
        </share-ad>
    </div>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview, Toast, Button, Skeleton } from 'vant'
import dialog from '@/components/dialog/index.vue'

export default {
    name: 'detail',
    data () {
        return {
            // h5标记
            H5: false,
            // ios标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // 当前轮播
            current: 0,
            // 弹窗数据
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            // 商品信息
            info: {
                imgUrls: []
            },
            // 表单数据
            formData: {
                sourceType: 1,
                type: 1,
                id: ''
            },
            // app类型
            appType: '',
            // 分享数据
            shareData: {},
            // 禁止标记
            disabled: true,
            // 骨架loading
            warpLoading: true,
            // loading
            loading: false,
            // 切换标记
            isChange: false
        }
    },
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Button.name]: Button,
        [Skeleton.name]: Skeleton,
        ctlDialog: dialog
    },
    methods: {
        onSwipeChange (index) {
            this.isChange = true
            this.current = index
        },
        onPPreview (index) {
            if (this.isChange) {
                this.isChange = false
                return
            }
            ImagePreview({
                images: this.info.imgUrls,
                startPosition: index,
                onChange: (index) => {
                    this.$refs.swipe.swipeTo(index)
                    this.current = index
                }
            })
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        submit () {
            if (this.H5) {
                this.linkApp()
                return
            }
            if (this.disabled) {
                return
            }
            this.loading = true
            this.$api.getChangeGoods(this.formData).then(res => {
                if (res.result.returnMsg) {
                    this.loading = false
                    this.dialogData = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.dialogData.visible = false
                        },
                        rightBtnMethod: () => {
                            this.dialogData.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '提示',
                        content: res.result.returnMsg
                    }
                } else {
                    this.$store.dispatch('setExchangeGoodsInfo', res.result)
                    this.$store.dispatch('setGoodsInfo', this.info)
                    this.$router.push('submitOrder')
                }
            })
        },
        getGoodsDetail () {
            this.loading = true
            this.warpLoading = true
            if (this.$route.query.shareType === 'h5') {
                return this.$api.getGoodsDetailPass(this.formData).then(res => {
                    setTimeout(() => {
                        this.warpLoading = false
                    }, 500)
                    this.loading = false
                    if (res.status && res.result) {
                        this.info = res.result
                        this.disabled = res.result.saleStatus !== 1
                    } else {
                        Toast.fail(res.message)
                    }
                })
            }

            return this.$api.getGoodsDetail(this.formData).then(res => {
                setTimeout(() => {
                    this.warpLoading = false
                }, 500)
                this.loading = false
                if (res.status && res.result) {
                    this.info = res.result
                    this.disabled = res.result.saleStatus !== 1
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 获取分享配置信息
        getSetting () {
            return this.$api.getAdSetting({ code: 'shops-detail' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                    this.$nextTick(() => {
                        // 标题
                        let title = this.shareData.shareTitle || this.info.name
                        // 内容
                        let content = '你的斑豆可以兑换商品哦~快来挑选吧！'

                        // 分享链接处理域名替换
                        let shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                        // 拼接路径
                        shareUrl += location.pathname

                        // 拼接参数
                        shareUrl += `?shareType=h5&appType=${this.appType}&id=${this.formData.id}`

                        // 图片链接
                        let imageUrl = this.shareData.shareImg || this.info.imgUrls[0]
                        // 页面编码
                        let pageCode = 'shops-detail'

                        if (Number(this.appType) !== 100) {
                            this.$jsBridge.callBackHandler('shareParams', { title, content, shareUrl, imageUrl, pageCode })
                        }
                    })
                }
            })
        }
    },
    async mounted () {
        // 设置app类型
        this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

        await this.getGoodsDetail()

        await this.getSetting()
    },
    created () {
        this.formData.id = this.$route.query.id
        this.formData.sourceType = this.$route.query.sourceType
        this.formData.type = this.$route.query.sourceType
        this.H5 = this.$route.query.shareType === 'h5'
    }
}
</script>
<style scoped lang="scss">
    .wrapper-detail {
        padding-bottom: 49px;
        box-sizing: border-box;
        min-height: 100%;

        /deep/ {
            .info {
                overflow: hidden;
                position: relative;

                * {
                    max-width: 375px;
                    word-break: break-word;
                    line-height: 1;
                }
            }

            .van-skeleton {
                padding: 0;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }

            .van-skeleton__title {
                margin-top: 5px;
                margin-left: 20px;
            }

            .van-skeleton__avatar {
                margin: 20px 0 0 0;
            }

            .van-skeleton__row {
                width: 335px !important;
                height: 20px;
                margin: 10px auto 0;
            }
        }
    }

    .van-swipe {
        line-height: 1;
        font-size: 0;
        height: 375px;
        overflow: hidden;
    }

    .van-swipe-item {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 100%;
        }
    }

    .custom-indicator {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 24px;
        right: 15px;
        bottom: 15px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 12px;
    }

    .title {
        background: #ffffff;
        padding: 20px 15px;
        border-bottom: 10px solid #FAFAFA;

        h2 {
            line-height: 1;
            font-size: 18px;
            font-weight: 600;
            color: #333333;
        }

        p {
            margin-top: 10px;
            line-height: 1;
            font-size: 15px;
            font-weight: 600;
            color: #333333;

            b {
                color: #FF5050;
            }
        }
    }

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 15px;
        border-bottom: 10px solid #FAFAFA;

        span:nth-child(1) {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
        }

        span:nth-child(2) {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
        }
    }

    .btn-submit {
        position: fixed;
        z-index: 999;
        bottom: 0;
        width: 375px;
        height: 49px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(83, 203, 133, 1);
        font-size: 18px;
        font-weight: 600;
        border: none;
        color: rgba(255, 255, 255, 1);

        &.disabled {
            background: #999999;
        }
    }
</style>
